import fetch from '@/common/utils/serFetch'
import { GATEWAYSER } from '@/common/config/index'

const moduleList = {
  customerStaffManager: `${GATEWAYSER.SQSIM}/customerStaffManager`,
  user: `${GATEWAYSER.SQSIM}/user`,
  public: `${GATEWAYSER.SQSIM}/public`,
  sysStaff: `${GATEWAYSER.SQSIM}/sysStaff`
}

export const customerServiceApi = {
  reqList(params) {
    return fetch.post(`${moduleList.customerStaffManager}/page`, params)
  },
  // 动态表头
  queryHead() {
    return fetch.get(`${moduleList.customerStaffManager}/head`)
  },
  // 添加 || 编辑
  update(params) {
    return fetch.post(`${moduleList.customerStaffManager}/update`, params)
  },
  // 获取详情
  queryDetail(id) {
    return fetch.get(`${moduleList.customerStaffManager}/detail?id=${id}`)
  },
  // 客服姓名
  queryAgentOptions() {
    return fetch.post(`${moduleList.customerStaffManager}/getConditionList`)
  },
  // 飞兔-账户
  getImAccount(key) {
    return fetch.get(`${moduleList.user}/list?account=${key}&current=1&size=99999999&isAgentEnable=2`)
  },
  // 外包-账户
  getOsAccount(key) {
    return fetch.get(`/servicequalityonline/public/getOpUserWebForPage?keyword=${key}&current=1&size=99999999`)
  },
  // 自营-账户
  getSeAccount(key) {
    return fetch.get(`/basicdata/sysStaff/getCustomerStaffPages?keyword=${key}&current=1&size=9999`)
  },
  // 导出
  reqExcel: params => fetch.download(`${GATEWAYSER.SQSIM}/report/customer_staff/export`, { ...params })
}
